import { UrlConstants } from "../url.constants";
export class ApiEhmsConstants {
    static URL = UrlConstants.API_V2 + "EhApplication";
    static PREMISES_URL = UrlConstants.API_V2 + "EhPremise";
    static FUNCTION_SET_APPLICANT = "SetEHApplicant";
    static FUNCTION_REMOVE_APPLICANT = "RemoveEHApplicant";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateEnvironmentalHealthInvoice";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetEhRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
}
